import { createSelector, createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: null,
  token: '',
};

try {
  const user = JSON.parse(localStorage.getItem('user-data'));
  initialState.user = user;
  initialState.token = user.access_token;
} catch (err) {}

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (state, { payload }) => {
      state.user = payload;
      state.token = payload.access_token;
      localStorage.setItem('user-data', JSON.stringify(payload));
    },
    logout: (state) => {
      state.user = null;
      state.token = '';
      localStorage.removeItem('user-data');
    },
  },
});

export default authSlice.reducer;

/***************************************************
 * selectors
 ***************************************************/

const selectSelf = (state) => state.auth;

export const selectorAuthenticated = createSelector(selectSelf, (state) => Boolean(state.user));

export const selectorUserInfo = createSelector(selectSelf, (state) => state.user);

export const selectorToken = createSelector(selectSelf, (state) => state.token);

export const selectorPermissions = createSelector(selectSelf, (state) => {
  const roles = state.user?.roles || [];
  const roleAdmin = roles.includes('role-app-admin');
  const roleStaff = roles.includes('role-cb-staff');
  const roleSupervisor = roles.includes('role-dcs-supervisor');
  //const roleParent = roles.includes('role-adoption-liaison-family');
  const roleChild = roles.includes('role-adoption-liaison');
  const roleReadOnly = roles.includes('role-dcs-read-only');
  // Child Summary Writer: can search and view children (read-only) and upload/download child documents
  const roleCsWriter = roles.includes('role-cs-writer');
  return {
    events: roleAdmin || roleStaff,
    reports: roleAdmin || roleStaff || roleSupervisor || roleReadOnly || roleChild,
    referralManagement: roleAdmin || roleStaff || roleSupervisor,
    writeParent: roleAdmin || roleStaff || roleSupervisor || roleChild,
    writeChild: roleAdmin || roleStaff || roleSupervisor || roleChild,
    admin: roleAdmin,
    adminStaffAndSuper: roleAdmin || roleStaff || roleSupervisor,
    csWriter: roleCsWriter,
    viewParents: !roleCsWriter,
    uploadChildDocuments: roleAdmin || roleStaff || roleSupervisor || roleChild || roleCsWriter,
  };
});

/***************************************************
 * actions
 ***************************************************/

export const { setCredentials, logout } = authSlice.actions;
